const ANIMATION_DURATION = 300
document.documentElement.style.setProperty('--reflinks-transition-duration', ANIMATION_DURATION / 1000 + 's')

/**
 * Flag que controlamos para saber se existe uma animação pendente.
 */
let hasPendingAnimation = false

/**
 * Tenta encontrar o efeito de animação entre a URL atual (document.location) e a URL especificada.
 *
 * @param {string} url
 * @return {string|null}
 */
export function getTransition(url) {
    let transitions = Array.from(document.head.querySelectorAll('meta[name="reflinks-transition"]'))
    let groupTransitions = transitions.filter(t => t.hasAttribute('group'))

    for (let groupMeta of groupTransitions) {
        let group = groupMeta.getAttribute('group')
        if (urlBelongsToGroup(group, document.location.pathname)) {
            if (urlBelongsToGroup(group, url)) {
                return groupMeta.getAttribute('transition')
            }
        }
    }
}

export function getGhost(url) {
    let transitions = Array.from(document.head.querySelectorAll('meta[name="reflinks-ghost"]'))
    let urlTransitionMeta = transitions.find(
        meta => meta.hasAttribute('url') && matchPatternUrl(meta.getAttribute('url'), url)
    )

    if (urlTransitionMeta) {
        return urlTransitionMeta.getAttribute('ghost')
    }

    let groupTransitions = transitions.filter(t => t.hasAttribute('group'))

    for (let groupMeta of groupTransitions) {
        let group = groupMeta.getAttribute('group')
        if (urlBelongsToGroup(group, url)) {
            return groupMeta.getAttribute('ghost')
        }
    }
}

/**
 * Se o usuário clicar rapidamente para navegar para outra página enquanto uma animação está acontecendo,
 * o sistema deve cancelar a animação anterior para que não haja problema de layout.
 */
export function waitForCurrentAnimationToFinish() {
    return new Promise(resolve => {
        let check = () => {
            if (!hasPendingAnimation) resolve()
            setTimeout(check, 50)
        }

        check()
    })
}

export function animateTransition(url, outElement, animation) {
    hasPendingAnimation = true
    prepareParentStyleForAnimation(outElement.parentElement)

    let outPosition = outElement.getBoundingClientRect()
    let inElement = document.createElement('div')

    inElement.style.position = 'absolute'
    inElement.style.width = outPosition.width + 'px'
    inElement.style.height = outPosition.height + 'px'
    inElement.style.top = '0px'
    inElement.style.left = '0px'

    outElement.insertAdjacentElement('afterend', inElement)

    if (animation == 'left-to-right') {
        outElement.classList.add('reflinks-transition-left-to-right-out')
        inElement.classList.add('reflinks-transition-left-to-right-in')
    } else if (animation == 'right-to-left') {
        outElement.classList.add('reflinks-transition-right-to-left-out')
        inElement.classList.add('reflinks-transition-right-to-left-in')
    }

    setTimeout(() => {
        requestAnimationFrame(() => {
            let parent = outElement.parentElement

            parent.removeChild(outElement)

            inElement.childNodes.forEach(node => {
                inElement.parentElement.appendChild(node)
            })

            inElement.parentElement.removeChild(inElement)

            restoreParentStyleAfterAnimation(parent)

            hasPendingAnimation = false
        })
    }, ANIMATION_DURATION)

    let ghost = getGhost(url)
    let target = document.createElement('div')

    if (ghost) {
        target.innerHTML = `<div class="animate-pulse">${ghostToHtml(ghost)}</div>`
    } else {
        target.innerHTML = `<div class="p-10 bg-gray-50">...</div>`
    }

    inElement.appendChild(target)

    return target
}

function ghostToHtml(ghost) {
    return ghost
        .split('+')
        .map(line => {
            switch (line) {
                case 'crud-title':
                    return `
                    <div class="p-unit flex items-center justify-between">
                        <div>
                            <div class="w-44 bg-gray-200 dark:bg-dark-900 h-4 rounded-full"></div>
                            <div class="mt-2 w-64 bg-gray-200 dark:bg-dark-900 h-4 rounded-full"></div>
                        </div>

                        <div class="w-32 bg-gray-200 dark:bg-dark-900 h-8 rounded"></div>
                    </div>
                `

                case 'crud-views':
                    return `
                    <div class="border-b dark:border-dark-200 flex items-center space-x-unit px-unit">
                        <div class="my-2 w-28 bg-gray-200 dark:bg-dark-900 h-4 rounded-full"></div>
                        <div class="my-2 w-32 bg-gray-200 dark:bg-dark-900 h-4 rounded-full"></div>
                    </div>
                `

                case 'crud-filters':
                    return `
                        <div class="p-unit flex items-center justify-between">
                            <div class="border-b dark:border-dark-200 w-56 h-6">
                            </div>

                            <div class="w-44 bg-gray-200 dark:bg-dark-900 h-8 rounded-full"></div>
                        </div>
                    `

                case 'table':
                    return `
                        <table class="w-full">
                            <thead class="p-2 bg-gray-100 dark:bg-dark-800">
                                <tr>
                                    <th class="p-2"><div class="p-2 w-5 h-5 bg-gray-200 dark:bg-dark-900 rounded"></div></th>
                                    <th class="p-2"><div class="p-2 w-24 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></th>
                                    <th class="p-2"><div class="p-2 w-28 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></th>
                                    <th class="p-2"><div class="p-2 w-16 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></th>
                                    <th class="p-2"><div class="p-2 w-20 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th class="p-2"><div class="p-2 w-5 h-5 bg-gray-200 dark:bg-dark-900 rounded"></div></th>
                                    <td class="p-2"><div class="p-2 w-32 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></td>
                                    <td class="p-2"><div class="p-2 w-36 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></td>
                                    <td class="p-2"><div class="p-2 w-28 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></td>
                                    <td class="p-2"><div class="p-2 w-28 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></td>
                                </tr>
                                <tr>
                                    <th class="p-2"><div class="p-2 w-5 h-5 bg-gray-200 dark:bg-dark-900 rounded"></div></th>
                                    <td class="p-2"><div class="p-2 w-28 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></td>
                                    <td class="p-2"><div class="p-2 w-16 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></td>
                                    <td class="p-2"><div class="p-2 w-36 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></td>
                                    <td class="p-2"><div class="p-2 w-24 h-4 bg-gray-200 dark:bg-dark-900 rounded-full"></div></td>
                                </tr>
                            </tbody>
                        </table>
                    `
            }
        })
        .join('')
}

function prepareParentStyleForAnimation(parent) {
    if (!parent) return
    parent.style.overflow = 'hidden'
}

function restoreParentStyleAfterAnimation(parent) {
    if (!parent) return
    parent.style.removeProperty('overflow')
}

function urlBelongsToGroup(group, url) {
    let patterns = getTransitionGroupPatterns(group)
    return !!patterns.find(pattern => matchPatternUrl(pattern, url))
}

function matchPatternUrl(pattern, url) {
    return pattern.indexOf(url) !== -1
}

function getTransitionGroupPatterns(group) {
    return Array.from(document.head.querySelectorAll(`meta[name="reflinks-transition-group"][group="${group}"]`)).map(
        meta => {
            return meta.getAttribute('pattern')
        }
    )
}
